/**
 * liveUpdates.ts — which request pages currently have a live (SSE) connection.
 *
 * While a request's stream is connected the server pushes a `request_update`
 * event whenever the request changes, so its queries only need a slow
 * safety-net poll. If the stream drops, they go back to fast polling.
 */

const live = new Set<string>();

export function setLive(requestId: string, connected: boolean): void {
  if (connected) live.add(requestId);
  else live.delete(requestId);
}

export function isLive(requestId: string): boolean {
  return live.has(requestId);
}

/** Poll intervals for an open request page. */
export const POLL_MS = {
  /** No live connection — poll often so changes still show within seconds. */
  fallback: 5_000,
  timelineFallback: 10_000,
  /** Live connection up — changes are pushed; this only catches a missed event. */
  live: 60_000,
} as const;
